import React from "react";
import "./Header.css";
const Header = () => {
  return (
    <div className="header-container">
      <div className="header-heading-container">
        <h1 className="header-heading">AlgoX</h1>
      </div>
    </div>
  );
};

export default Header;
